const navRoutes = {
    'bristol-property-maintenance': 'bristol-property-maintenance',
    'clifton-property-maintenance': 'clifton-property-maintenance',
    'redland-property-maintenance': 'redland-property-maintenance',
    'bedminster-property-maintenance': 'bedminster-property-maintenance',
    'totterdown-property-maintenance': 'totterdown-property-maintenance',
    'horfield-property-maintenance': 'horfield-property-maintenance',
    'bishopston-property-maintenance': 'bishopston-property-maintenance',
    'cotham-property-maintenance': 'cotham-property-maintenance',
    'stoke-bishop-property-maintenance': 'stoke-bishop-property-maintenance',
    'westbury-on-trym-property-maintenance': 'westbury-on-trym-property-maintenance',
    'fishponds-property-maintenance': 'fishponds-property-maintenance',
    'easton-property-maintenance': 'easton-property-maintenance',
    'montpelier-property-maintenance': 'montpelier-property-maintenance',
    'st-george-property-maintenance': 'st-george-property-maintenance',
    'kingswood-property-maintenance': 'kingswood-property-maintenance',
    'hanham-property-maintenance': 'hanham-property-maintenance',
    'bradley-stoke-property-maintenance': 'bradley-stoke-property-maintenance',
    'downend-property-maintenance': 'downend-property-maintenance',
    'long-ashton-property-maintenance': 'long-ashton-property-maintenance',
    'emersons-green-property-maintenance': 'emersons-green-property-maintenance',
    'portishead-property-maintenance': 'portishead-property-maintenance',
    'clevedon-property-maintenance': 'clevedon-property-maintenance',
    'filton-property-maintenance': 'filton-property-maintenance',
    'patchway-property-maintenance': 'patchway-property-maintenance',
    'keynsham-property-maintenance': 'keynsham-property-maintenance',
    'yate-property-maintenance': 'yate-property-maintenance',
    'nailsea-property-maintenance': 'nailsea-property-maintenance',
    'st-apollonia-handyman': 'st-apollonia-handyman',
    'bristol-city-centre-handyman': 'bristol-city-centre-handyman',
    'bedminster-handyman': 'bedminster-handyman',
    'clifton-handyman': 'clifton-handyman'
};

module.exports = navRoutes;
